import React, { useState, useEffect, useRef, useCallback } from 'react';
import phoneFrame from '../../../../assets/smartxonnect/phone.webp';
import leftArrow from '../../../../assets/smartxonnect/left.webp';
import rightArrow from '../../../../assets/smartxonnect/right.webp';
import './BaasBeforeTheRideCarousel.scss';
// import SmartXonnectUsage from '../SmartXonnectUsage/SmartXonnectUsage';

const BaasBeforeTheRideCarousel = ({ fields }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [prevSlide, setPrevSlide] = useState(fields.CarouselCards.length - 1);
  const [nextSlide, setNextSlide] = useState(1);

  const touchStartX = useRef(0);
  const touchEndX = useRef(0);
  const threshold = 50;

  const pushToDataLayer = (currentSlide, interactionType) => {
    const currentCard = fields.CarouselCards[currentSlide];
    dataLayer.push({
      event: 'before_the_ride_banner_navigation',
      banner_name: currentCard.name,
      cta_text: interactionType,
      BrandName: 'TVS iQube',
      VariantName: 'SmartXonnect',
    });
  };

  const updateSlides = (newCurrent, interactionType = 'auto') => {
    setCurrentSlide(newCurrent);
    setPrevSlide((newCurrent - 1 + fields.CarouselCards.length) % fields.CarouselCards.length);
    setNextSlide((newCurrent + 1) % fields.CarouselCards.length);
    pushToDataLayer(newCurrent, interactionType);
  };

  const goToNext = useCallback(() => {
    updateSlides((currentSlide + 1) % fields.CarouselCards.length, 'right_arrow');
  }, [currentSlide, fields.CarouselCards.length]);

  const goToPrev = useCallback(() => {
    updateSlides(
      (currentSlide - 1 + fields.CarouselCards.length) % fields.CarouselCards.length,
      'left_arrow'
    );
  }, [currentSlide, fields.CarouselCards.length]);

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    touchEndX.current = e.changedTouches[0].clientX;
    const deltaX = touchStartX.current - touchEndX.current;

    if (Math.abs(deltaX) > threshold) {
      if (deltaX > 0) {
        goToNext();
      } else {
        goToPrev();
      }
    }
  };

  useEffect(() => {
    updateSlides(0);
  }, [fields.CarouselCards.length]);

  const getSlideClass = (index) => {
    if (index === currentSlide) return 'active';
    if (index === prevSlide) return 'prev';
    if (index === nextSlide) return 'next';
    return '';
  };

  const goToSlide = useCallback((index) => {
    updateSlides(index, 'dot_click');
  }, []);

  return (
    <div className="before-ride-wrapper">
      {/* <SmartXonnectUsage /> */}
      <div className="gradient-background"></div>
      <div className="before-ride-section" data-aos="fade-up">
        <div className="header-section-wrapper">
          <h2>
            <span>1</span>Plan Your Ride
          </h2>
        </div>
        <div
          className="carousel-container"
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
        >
          <div className="phone-frame-container">
            <img src={phoneFrame} alt="Phone frame" className="phone-frame" loading="lazy" />
          </div>
          <div className="carousel-slides">
            {fields.CarouselCards.map((image, index) => (
              <div key={index} className={`carousel-slide ${getSlideClass(index)}`}>
                <div className="image-container">
                  <img
                    src={image.fields.CardMedia.value.src}
                    alt={image.fields.CardMedia.value.alt}
                    className="carousel-image"
                    loading="lazy"
                  />
                </div>
              </div>
            ))}
          </div>
          <img
            src={leftArrow}
            alt="Left Arrow"
            className="left-arrow"
            onClick={goToPrev}
            loading="lazy"
          />
          <img
            src={rightArrow}
            alt="Right Arrow"
            className="right-arrow"
            onClick={goToNext}
            loading="lazy"
          />
          <div className="carousel-indicators">
            {fields.CarouselCards.map((_, index) => (
              <div
                key={index}
                className={`indicator-dot ${index === currentSlide ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
              />
            ))}
          </div>
        </div>
        <div className="carousel-content">
          <div className="carousel-footer-section">
            <h2 className="card-main-header">{fields.CarouselCards[currentSlide].name}</h2>
            <h3 className="card-header">
              {fields.CarouselCards[currentSlide].fields.CardTitle.value}
            </h3>
            <p className="card-sub-header">
              {fields.CarouselCards[currentSlide].fields.CardSubtitle.value}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(BaasBeforeTheRideCarousel);
